export const buildEnvironment = {
"buildId":"308875",
"buildDate":"2023-10-24T15:03:44.666Z",
"buildTimeStamp":1698159824666,
"ngVersion":"13.3.2",
"version":"6.0.4719",
"api":"21.01",
"environment":"prod",
"production":true
};